(function () {
  'use strict';

  var SEL = {
    section: '.vg-buy',
    flavorLabel: '.vg-buy__flavor',
    bundleLabel: '.vg-buy__bundle',
    optionCard: '.vg-buy__option',
    ctaBtn: '.vg-buy__cta-btn',
    variantInput: '.product-variant-id',
    qtyInput: '.vg-buy__qty-input',
    sellingPlanInput: '.vg-buy__selling-plan-input',
    subscribePrice: '[data-subscribe-price]',
    onetimePrice: '[data-onetime-price]',
    comparePrice: '[data-compare-price]',
    pricePerUnit: '[data-price-per-unit]',
    mixToggle: '[data-mix-toggle]',
  };

  var instances = new WeakMap();

  function VgBuyBox(section) {
    this.section = section;
    this.sectionId = section.dataset.sectionId;
    this._handlers = [];

    var dataEl = document.getElementById('vg-buy-product-data-' + this.sectionId);
    if (!dataEl) return;

    try {
      this.productData = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    if (!this.productData || !this.productData.variants || !this.productData.variants.length) return;

    this.bundleMap = this._buildBundleMap();
    this.promoDiscountMap = this._buildPromoDiscountMap();
    this.promoApplied = false;
    this.currentOptions = this._getInitialOptions();
    this.selectedBundleQty = this._getSelectedBundleQty();
    this.purchaseType = this._getSelectedPurchaseType();
    this.isMixed = false;

    this._bindEvents();
    this._bindPromoEvents();
    this._updateMixToggleVisibility();
    this._updatePriceDisplay();
    this._updateCtaText();
  }

  VgBuyBox.prototype._buildBundleMap = function () {
    var map = {};
    var bundles = (this.productData.bundles || []).filter(Boolean);
    for (var i = 0; i < bundles.length; i++) {
      map[bundles[i].qty] = bundles[i].price;
    }
    return map;
  };

  VgBuyBox.prototype._buildPromoDiscountMap = function () {
    var map = {};
    var bundles = (this.productData.bundles || []).filter(Boolean);
    for (var i = 0; i < bundles.length; i++) {
      map[bundles[i].qty] = bundles[i].promoDiscount || 0;
    }
    return map;
  };

  VgBuyBox.prototype._bindPromoEvents = function () {
    var self = this;
    var promo = this.productData.promo;
    if (!promo || !promo.enabled) return;

    var applyBtn = this.section.querySelector('[data-promo-apply]');
    var input = this.section.querySelector('[data-promo-input]');
    if (!applyBtn || !input) return;

    var handleApply = function () { self._onPromoApply(); };
    this._addHandler(applyBtn, 'click', handleApply);
    this._addHandler(input, 'keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); handleApply(); }
    });
  };

  VgBuyBox.prototype._onPromoApply = function () {
    var promo = this.productData.promo;
    if (!promo) return;

    var input = this.section.querySelector('[data-promo-input]');
    var msgEl = this.section.querySelector('[data-promo-msg]');
    var promoSection = this.section.querySelector('[data-promo-section]');
    if (!input || !msgEl) return;

    var entered = (input.value || '').trim().toUpperCase();
    var validCode = (promo.code || '').trim().toUpperCase();

    if (this.promoApplied) {
      /* Toggle off — remove promo */
      this.promoApplied = false;
      input.value = '';
      input.disabled = false;
      msgEl.hidden = true;
      msgEl.className = 'vg-buy__promo-msg';
      if (promoSection) promoSection.classList.remove('vg-buy__promo--applied');
      var applyBtn = this.section.querySelector('[data-promo-apply]');
      if (applyBtn) applyBtn.textContent = 'Apply';
      this._updatePriceDisplay();
      this._updateBundleBadges();
      return;
    }

    if (!entered) {
      msgEl.hidden = false;
      msgEl.className = 'vg-buy__promo-msg vg-buy__promo-msg--error';
      msgEl.textContent = 'Please enter a code.';
      return;
    }

    if (entered === validCode) {
      this.promoApplied = true;
      input.disabled = true;
      msgEl.hidden = false;
      msgEl.className = 'vg-buy__promo-msg vg-buy__promo-msg--success';
      msgEl.textContent = promo.successText || 'Code applied!';
      if (promoSection) promoSection.classList.add('vg-buy__promo--applied');
      var applyBtn2 = this.section.querySelector('[data-promo-apply]');
      if (applyBtn2) applyBtn2.textContent = 'Remove';
      this._updatePriceDisplay();
      this._updateBundleBadges();
    } else {
      msgEl.hidden = false;
      msgEl.className = 'vg-buy__promo-msg vg-buy__promo-msg--error';
      msgEl.textContent = promo.errorText || 'Invalid code.';
    }
  };

  VgBuyBox.prototype._updateBundleBadges = function () {
    var self = this;
    this.section.querySelectorAll(SEL.bundleLabel).forEach(function (label) {
      var qty = parseInt(label.dataset.bundleQty, 10);
      var existingSavings = label.querySelector('.vg-buy__promo-savings');
      if (existingSavings) existingSavings.remove();

      if (self.promoApplied) {
        var discount = self.promoDiscountMap[qty] || 0;
        if (discount > 0) {
          var badge = document.createElement('span');
          badge.className = 'vg-buy__promo-savings';
          badge.textContent = '+' + discount + '% OFF';
          label.appendChild(badge);
        }
      }
    });
  };

  VgBuyBox.prototype._getInitialOptions = function () {
    var options = {};
    var activeFlavorEl = this.section.querySelector('.vg-buy__flavor.is-active');
    if (activeFlavorEl) {
      options.flavor = activeFlavorEl.dataset.flavorValue;
    }
    return options;
  };

  VgBuyBox.prototype._getSelectedBundleQty = function () {
    var el = this.section.querySelector('.vg-buy__bundle.is-active');
    return el ? parseInt(el.dataset.bundleQty, 10) : 1;
  };

  VgBuyBox.prototype._getSelectedPurchaseType = function () {
    var el = this.section.querySelector('.vg-buy__option.is-active');
    return el ? el.dataset.purchaseType : 'onetime';
  };

  VgBuyBox.prototype._addHandler = function (el, event, fn) {
    el.addEventListener(event, fn);
    this._handlers.push({ el: el, event: event, fn: fn });
  };

  VgBuyBox.prototype._bindEvents = function () {
    var self = this;

    this.section.querySelectorAll(SEL.flavorLabel).forEach(function (label) {
      self._addHandler(label, 'click', function () { self._onFlavorSelect(label); });
      self._addHandler(label, 'keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self._onFlavorSelect(label); }
      });
    });

    this.section.querySelectorAll(SEL.bundleLabel).forEach(function (label) {
      self._addHandler(label, 'click', function () { self._onBundleSelect(label); });
      self._addHandler(label, 'keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self._onBundleSelect(label); }
      });
    });

    this.section.querySelectorAll(SEL.optionCard).forEach(function (card) {
      self._addHandler(card, 'click', function () { self._onPurchaseTypeSelect(card); });
      self._addHandler(card, 'keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self._onPurchaseTypeSelect(card); }
      });
    });

    var mixCheckbox = this.section.querySelector('[data-mix-toggle] input[type="checkbox"]');
    if (mixCheckbox) {
      self._addHandler(mixCheckbox, 'change', function () {
        self.isMixed = mixCheckbox.checked;
        self._updatePriceDisplay();
      });
    }
  };

  VgBuyBox.prototype.destroy = function () {
    this._handlers.forEach(function (h) { h.el.removeEventListener(h.event, h.fn); });
    this._handlers = [];
  };

  VgBuyBox.prototype._onFlavorSelect = function (label) {
    this.section.querySelectorAll(SEL.flavorLabel).forEach(function (el) { el.classList.remove('is-active'); });
    label.classList.add('is-active');
    var radio = label.querySelector('input[type="radio"]');
    if (radio) radio.checked = true;
    this.currentOptions.flavor = label.dataset.flavorValue;
    this._updateVariant();
    this._updatePriceDisplay();
    this._updateNutritionIngredients();
  };

  /* ── Switch Nutrition/Ingredients based on flavor ── */
  VgBuyBox.prototype._updateNutritionIngredients = function () {
    var flavor = (this.currentOptions.flavor || '').toLowerCase();
    var isBlackBean = flavor.indexOf('black') !== -1 || flavor.indexOf('soritae') !== -1 || flavor.indexOf('bean') !== -1;

    // Nutrition Facts data per flavor (OSOT values)
    var nfData = isBlackBean
      ? { cal: '180', fat: '3.5g', fatDv: '4%', sodium: '200mg', sodiumDv: '9%', carb: '15g', carbDv: '5%', fiber: '13g', fiberDv: '46%', sugar: '<1g', protein: '22g', calcium: '180mg', calciumDv: '14%', iron: '3.7mg', ironDv: '20%', potassium: '340mg', potassiumDv: '8%' }
      : { cal: '170', fat: '1g', fatDv: '1%', sodium: '240mg', sodiumDv: '10%', carb: '18g', carbDv: '7%', fiber: '15g', fiberDv: '54%', sugar: '0g', protein: '22g', calcium: '230mg', calciumDv: '18%', iron: '5.2mg', ironDv: '30%', potassium: '170mg', potassiumDv: '4%' };

    var map = {
      '[data-nf-cal]': nfData.cal, '[data-nf-fat]': nfData.fat, '[data-nf-fat-dv]': nfData.fatDv,
      '[data-nf-sodium]': nfData.sodium, '[data-nf-sodium-dv]': nfData.sodiumDv,
      '[data-nf-carb]': nfData.carb, '[data-nf-carb-dv]': nfData.carbDv,
      '[data-nf-fiber]': nfData.fiber, '[data-nf-fiber-dv]': nfData.fiberDv,
      '[data-nf-sugar]': nfData.sugar, '[data-nf-protein]': nfData.protein,
      '[data-nf-calcium]': nfData.calcium, '[data-nf-calcium-dv]': nfData.calciumDv,
      '[data-nf-iron]': nfData.iron, '[data-nf-iron-dv]': nfData.ironDv,
      '[data-nf-potassium]': nfData.potassium, '[data-nf-potassium-dv]': nfData.potassiumDv
    };

    var section = this.section;
    Object.keys(map).forEach(function (sel) {
      var el = section.querySelector(sel);
      if (el) el.textContent = map[sel];
    });

    // Toggle ingredients
    var matchaIng = section.querySelector('[data-ingredients-matcha]');
    var bbIng = section.querySelector('[data-ingredients-blackbean]');
    if (matchaIng) matchaIng.style.display = isBlackBean ? 'none' : 'block';
    if (bbIng) bbIng.style.display = isBlackBean ? 'block' : 'none';
  };

  VgBuyBox.prototype._onBundleSelect = function (label) {
    this.section.querySelectorAll(SEL.bundleLabel).forEach(function (el) { el.classList.remove('is-active'); });
    label.classList.add('is-active');
    var radio = label.querySelector('input[type="radio"]');
    if (radio) radio.checked = true;

    this.selectedBundleQty = parseInt(label.dataset.bundleQty, 10) || 1;
    var qtyInput = this.section.querySelector(SEL.qtyInput);
    if (qtyInput) qtyInput.value = this.selectedBundleQty;

    this._updateMixToggleVisibility();
    this._updatePriceDisplay();
  };

  VgBuyBox.prototype._onPurchaseTypeSelect = function (card) {
    this.section.querySelectorAll(SEL.optionCard).forEach(function (el) { el.classList.remove('is-active'); });
    card.classList.add('is-active');
    var radio = card.querySelector('input[type="radio"]');
    if (radio) radio.checked = true;

    this.purchaseType = card.dataset.purchaseType;

    var sellingPlanInput = this.section.querySelector(SEL.sellingPlanInput);
    if (sellingPlanInput) {
      if (this.purchaseType === 'subscribe' && this.productData.sellingPlans && this.productData.sellingPlans.length > 0) {
        sellingPlanInput.value = this.productData.sellingPlans[0].id;
      } else {
        sellingPlanInput.value = '';
      }
    }

    this._updateCtaText();
    this._updatePriceDisplay();
  };

  VgBuyBox.prototype._updateMixToggleVisibility = function () {
    var mixEl = this.section.querySelector(SEL.mixToggle);
    if (!mixEl) return;

    if (this.selectedBundleQty >= 2) {
      mixEl.hidden = false;
    } else {
      mixEl.hidden = true;
      var checkbox = mixEl.querySelector('input[type="checkbox"]');
      if (checkbox) { checkbox.checked = false; this.isMixed = false; }
    }
  };

  VgBuyBox.prototype._updateVariant = function () {
    var matchingVariant = this._findVariantByOptions();
    if (!matchingVariant) return;

    var variantInput = this.section.querySelector(SEL.variantInput);
    if (variantInput) {
      variantInput.value = matchingVariant.id;
      variantInput.disabled = !matchingVariant.available;
    }

    var ctaBtn = this.section.querySelector(SEL.ctaBtn);
    if (ctaBtn) {
      ctaBtn.disabled = !matchingVariant.available;
      if (!matchingVariant.available) {
        var span = ctaBtn.querySelector('span');
        var soldText = ctaBtn.dataset.soldOutText || 'Sold Out';
        if (span) { span.textContent = soldText; } else { ctaBtn.textContent = soldText; }
      } else {
        this._updateCtaText();
      }
    }

    window.dispatchEvent(new CustomEvent('veggiet:variant-change', {
      detail: { variantId: matchingVariant.id, variant: matchingVariant, sectionId: this.sectionId }
    }));
  };

  VgBuyBox.prototype._findVariantByOptions = function () {
    if (!this.productData.variants.length) return null;
    if (!this.currentOptions.flavor) return this.productData.variants[0];

    var options = this.productData.options || [];
    var flavorIdx = -1;
    for (var i = 0; i < options.length; i++) {
      var opt = options[i].toLowerCase();
      if (opt === 'flavor' || opt === 'flavour' || opt === 'taste') { flavorIdx = i; break; }
    }
    if (flavorIdx === -1) return this.productData.variants[0];

    var target = this.currentOptions.flavor;
    for (var j = 0; j < this.productData.variants.length; j++) {
      if (this.productData.variants[j].options[flavorIdx] === target) return this.productData.variants[j];
    }
    return this.productData.variants[0];
  };

  VgBuyBox.prototype._getBundlePrice = function () {
    return this.bundleMap[this.selectedBundleQty] || (this.selectedBundleQty * 4790);
  };

  VgBuyBox.prototype._getPromoDiscount = function () {
    if (!this.promoApplied) return 0;
    return this.promoDiscountMap[this.selectedBundleQty] || 0;
  };

  VgBuyBox.prototype._updatePriceDisplay = function () {
    var bundlePrice = this._getBundlePrice();
    var discount = this.productData.subscribeDiscount || 15;
    var promoDiscount = this._getPromoDiscount();

    /* Apply promo discount to bundle price */
    var effectiveBundlePrice = bundlePrice;
    if (promoDiscount > 0) {
      effectiveBundlePrice = Math.round(bundlePrice * (1 - promoDiscount / 100));
    }

    var subscribeTotal = Math.round(effectiveBundlePrice * (1 - discount / 100));
    var onetimeTotal = effectiveBundlePrice;
    var singleBoxPrice = this.bundleMap[1] || 4790;
    var compareTotal = singleBoxPrice * this.selectedBundleQty;

    var subscribePriceEl = this.section.querySelector(SEL.subscribePrice);
    if (subscribePriceEl) subscribePriceEl.textContent = this._formatMoney(subscribeTotal);

    var comparePriceEl = this.section.querySelector(SEL.comparePrice);
    if (comparePriceEl) {
      var showCompare = compareTotal > effectiveBundlePrice || this.purchaseType === 'subscribe' || promoDiscount > 0;
      comparePriceEl.style.display = showCompare ? 'block' : 'none';
      if (this.purchaseType === 'subscribe') {
        comparePriceEl.textContent = this._formatMoney(bundlePrice);
      } else if (promoDiscount > 0) {
        comparePriceEl.textContent = this._formatMoney(bundlePrice);
      } else {
        comparePriceEl.style.display = compareTotal > bundlePrice ? 'block' : 'none';
        comparePriceEl.textContent = this._formatMoney(compareTotal);
      }
    }

    var onetimePriceEl = this.section.querySelector(SEL.onetimePrice);
    if (onetimePriceEl) onetimePriceEl.textContent = this._formatMoney(onetimeTotal);

    this.section.querySelectorAll(SEL.pricePerUnit).forEach(function (el) {
      var perBox = Math.round(effectiveBundlePrice / this.selectedBundleQty);
      if (this.purchaseType === 'subscribe') {
        perBox = Math.round(subscribeTotal / this.selectedBundleQty);
      }
      el.textContent = this._formatMoney(perBox) + '/box';
    }.bind(this));
  };

  VgBuyBox.prototype._formatMoney = function (cents) {
    if (cents == null || isNaN(cents)) return '$0.00';
    var format = (this.productData && this.productData.moneyFormat) || '${{amount}}';
    var amount = (Math.abs(cents) / 100).toFixed(2);
    var amountNoDecimals = Math.floor(Math.abs(cents) / 100).toString();

    var parts = amount.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amountWithCommaSeparator = intPart + '.' + (parts[1] || '00');

    return format
      .replace('{{amount_with_comma_separator}}', amountWithCommaSeparator)
      .replace('{{amount_no_decimals_with_comma_separator}}', intPart.replace(/,/g, '.'))
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount_with_apostrophe_separator}}', amount.replace('.', "'"))
      .replace('{{amount}}', amount);
  };

  VgBuyBox.prototype._updateCtaText = function () {
    var ctaBtn = this.section.querySelector(SEL.ctaBtn);
    if (!ctaBtn || ctaBtn.disabled) return;

    var isPreorder = ctaBtn.dataset.preorderMode === 'true';
    var text;
    if (isPreorder) {
      text = ctaBtn.dataset.preorderText || 'Pre-Order Now';
    } else if (this.purchaseType === 'subscribe') {
      text = ctaBtn.dataset.subscribeText || 'START NOW';
    } else {
      text = ctaBtn.dataset.onetimeText || 'ADD TO CART';
    }

    var span = ctaBtn.querySelector('span');
    if (span) {
      span.textContent = text;
    } else {
      ctaBtn.textContent = text;
    }
  };

  function init() {
    document.querySelectorAll(SEL.section).forEach(function (section) {
      if (instances.has(section)) return;
      var instance = new VgBuyBox(section);
      instances.set(section, instance);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector(SEL.section);
      if (section) {
        var prev = instances.get(section);
        if (prev && prev.destroy) prev.destroy();
        instances.delete(section);
        instances.set(section, new VgBuyBox(section));
      }
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var section = e.target.querySelector(SEL.section);
      if (section) {
        var prev = instances.get(section);
        if (prev && prev.destroy) prev.destroy();
        instances.delete(section);
      }
    });
  }
})();
